enum ConfigurationReference {
    ActiveSeason = 'ACTIVE_SEASON',
    SalesCampaign = 'SALES_CAMPAIGN',
    Insurance = 'INSURANCE',
    EngineeringInsurancePercentage = 'ENGINEERING_INSURANCE_PERCENTAGE'
}

export default ConfigurationReference;
